import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectThreads } from 'store/chat/services/getProjectThreads.service';
import v4 from 'uuid/v4';

export const getProjectThreadsThunk = createAsyncThunk(
  'chat/getProjectThreads',
  async ({ projects, chatWebsocketRef, userId }, { getState }) => {
    const projectIds = projects.map((project) => project.id);
    const threadsResult = await getProjectThreads({ projectIds });
    const state = getState().chatSlice;
    const threadsByProject = state.threadsByProject || {};
    const activeThread = state.thread;

    let threads = {};
    for (const thread of threadsResult) {
      const project = projects.find((p) => p.id === thread.projectId);
      if (project) {
        threads[thread.projectId] = {
          ...thread,
          parent: project.parent,
          children: [],
          unreadMessagesInChildProjects: 0,
        };
        if (!threadsByProject[thread.projectId]) {
          const socketValidObject = {
            newThreadConnection: {
              id: v4(),
              userId: userId,
              threadId: thread.id,
              isActive: thread.id === activeThread?.id,
            },
          };
          chatWebsocketRef.current.send(JSON.stringify(socketValidObject));
        }
      }
    }

    for (const [projectId, thread] of Object.entries(threads)) {
      if (thread.parent) {
        let hasParents = true;
        let parentThread = threads[thread.parent];
        while (hasParents && parentThread) {
          parentThread.children.push(thread);
          parentThread.unreadMessagesInChildProjects +=
            thread.unreadMessagesCount;
          hasParents = Boolean(parentThread.parent);
          if (hasParents) {
            parentThread = threads[parentThread.parent];
          }
        }
      }
    }
    const threadsResultMap = threadsResult.reduce((acc, thread) => {
      acc[thread.id] = thread;
      return acc;
    }, {});

    return { threadsByProject: threads, threads: threadsResultMap };
  }
);
